import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as LeftDoubleArrow } from "../../assets/images/icons/CustomerTableleftarr.svg";
import { ReactComponent as RightDoubleArrow } from "../../assets/images/icons/Custumertablearrow.svg";
import CreatePortalHOC from "../GlobalFeature/Fields/CreatePortalHOC";
import { getPortalPosition } from "../../utils/utilityFunctions/stringUtility";
import { useLocation } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import Button from "./DefaultButton";

function ScrollableTabs({ tabData, tabColor, activeTab, handleTabClick }) {
  console.log("params for scrollableTabs", tabData, tabColor, activeTab, handleTabClick);

  const [showTabList, setShowTabList] = useState(false);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [nonVisibleTabCount, setNonVisibleTabCount] = useState(0);

  const location = useLocation();

  // const hashValue = location.hash.substring(1);
  const hashValue = location.hash;

  // const [activeTab, setActiveTab] = useState(Boolean(hashValue.replace("#", "")) ? hashValue : "#all");

  const scrollDiv = useRef();
  const moreTabRef = useRef();
  const tabListRef = useRef();

  let scrollInterval;
  // = useRef();

  function scrollTheElement(elem, direction) {
    console.log("elemaa", direction);
    const scrollAmount = 50; // Amount to scroll in pixels per interval

    scrollInterval = setInterval(() => {
      if (direction === "left") {
        elem.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      } else if (direction === "right") {
        elem.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }, 50);
  }

  function stopScroll() {
    // Stop scrolling when the button is released
    console.log("isScrooling", scrollInterval);
    clearInterval(scrollInterval);
  }

  // const handleTabClick = (tab) => {

  //     setActiveTab(tab);
  //   };

  function tabListHandler(tabName) {
    // window.location.href = `#${tabName}`
    const element = document.getElementById(`tab-${tabName}`);
    element.scrollIntoView({ behavior: "smooth" });
    handleTabClick(`#${tabName}`);
  }

  const getMoreTabStatus = (ele, ele2) => {
    if (ele && ele.current && ele2 && ele2.current) {
      const rec = ele.current.getBoundingClientRect();
      const rec2 = ele2.current.getBoundingClientRect();

      let totalWidth = 0;
      if (ele.current.children.length > 0) {
        //  totalWidth = ele.current?.children?.reduce(
        //   (acc, curr) => {
        //     const currRec = curr.getBoundingClientRect();
        //     acc += currRec.width;
        //     console.log("recccc", acc, currRec)
        //     return acc;
        // },0)
      }
      function visibleChildren(ulElement, refWidth) {
        let totalWidth = 0;
        let count = 0;

        for (const child of ulElement.children) {
          const childWidth = child.getBoundingClientRect().width;
          totalWidth += childWidth;
          count++;
          if (totalWidth > refWidth - 95) {
            return count; // Exit early when condition is matched
          }
        }
        return 0; // If the reference width is never exceeded
      }

      if (ele.current.children.length > 0) {
        setNonVisibleTabCount(ele.current.children.length - visibleChildren(ele.current, rec2.width));
      }
      if (rec.width > rec2.width) {
        setShowLeftArrow(true);
        setShowRightArrow(true);
        // return true
      }
    }

    return false;
  };

  const renderTabs = () => (
    <>
      {tabData?.map((type) => (
        <a
          // href={`#${type.type}`}
          key={type.type}
          className={`cursor-pointer whitespace-nowrap rounded-md px-2 py-1 items-center focus:outline-none text-[13px]  ${activeTab === `#${type.type}` ? "text-white bg-primary  font-semibold " : "text-[#13131399] hover:text-primary font-medium"}`}
          onClick={() => handleTabClick(`#${type.type}`)}
        >
          {type.type}
        </a>
      ))}
      {/* {tabData &&
        Object.entries(tabData).map(([key, count], i) => {
          const tab_Color = tabColor?.[key?.toLowerCase()] || null;

          return (
            <>
              <li key={key} id={`tab-${key}`}>
                <a
                  href={`#${key}`}
                  onClick={() => handleTabClick(`#${key}`)}
                  style={{
                    border:
                      key === "all" && activeTab === `#${key}`
                        ? "1px solid green"
                        : activeTab === `#${key}`
                          ? `1px solid ${tab_Color}`
                          : "1px solid #D2DAE1",

                    color: activeTab === `#${key}` ? tab_Color : "#848687", // No change for color

                    backgroundColor:
                      key === "all" && activeTab === `#${key}`
                        ? "rgba(0, 128, 0, 0.1)" // Green with low opacity
                        : activeTab === `#${key}`
                          ? `${tab_Color}1A`
                          : "white",
                  }}
                  className={`flex min-w-[69px] justify-center items-center py-1 px-2.5 whitespace-nowrap 
                    leading-normal font-normal text-sm capitalize rounded-[50px]  border 
                      
                    ${key.toLowerCase() === "overdue" && "!text-FF3612"} `}
                >
                  {key}
                </a>
              </li>
            </>
          );
        })} */}
    </>
  );

  useEffect(() => {
    // console.log("recc useEF",)
    getMoreTabStatus(tabListRef, scrollDiv);
  }, [renderTabs]);

  const [isScrolling, setIsScrolling] = useState(false); // State to control scrolling

  useEffect(() => {
    let animationFrameId;

    // Function to handle auto-scrolling
    const autoScroll = () => {
      if (scrollDiv.current && isScrolling) {
        scrollDiv.current.scrollBy(0, 1); // Scroll down 1px
        animationFrameId = requestAnimationFrame(autoScroll); // Keep scrolling
      }
    };

    // Start scrolling when isScrolling is true
    if (isScrolling) {
      autoScroll();
    }

    // Cleanup on component unmount or when scrolling stops
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [isScrolling]);

  return (
    <div className="flex items-center bg-white grow min-w-0 rounded-[5px]  ">
      <div className="w-full overflow-auto flex items-center no-scrollbar gap-2">
        {showLeftArrow && (
          <div className=" mx-1 w-7 h-7 rounded-[5px] hover:bg-primary-hover flex items-center justify-center">
            <LeftDoubleArrow
              className="cursor-pointer fill-[#767676] hover:fill-primary"
              onMouseDown={() => scrollTheElement(scrollDiv, "left")}
              onMouseUp={() => stopScroll()}
              onMouseLeave={() => stopScroll()}
            />
          </div>
        )}
        <div
          className="flex items-center overflow-y-auto no-scrollbar "
          ref={scrollDiv}
          // onScroll={()=> handleScroll(scrollDiv)}
        >
          <ul className="hidden md:flex space-x-3" ref={tabListRef}>
            {renderTabs()}
          </ul>
        </div>

        {showRightArrow && (
          <>
            <div className="w-7 h-7 rounded-[5px] hover:bg-primary-hover flex items-center justify-center">
              <RightDoubleArrow
                items-center
                className="cursor-pointer fill-[#767676] hover:fill-primary"
                onMouseDown={() => scrollTheElement(scrollDiv, "right")}
                onMouseUp={() => stopScroll()}
                onMouseLeave={() => stopScroll()}
              />
            </div>
            {/* <span
              onClick={() => setShowTabList(!showTabList)}
              className="flex min-w-[95px] justify-center items-center py-1 px-2.5 focus:block whitespace-nowrap leading-normal font-normal text-xs capitalize rounded-[50px] bg-white border"
              ref={moreTabRef}
            >
              +{nonVisibleTabCount} More
            </span> */}
          </>
        )}

        {showTabList && (
          <CreatePortalHOC
            isOpen={showTabList}
            onClose={() => setShowTabList(false)}
            position={getPortalPosition(moreTabRef, "bottom", "left", -4, 0)}
            verticalDist={8}
          >
            <div className="w-fit bg-white p-2 rounded-lg">
              {
                <ul className="mb-2">
                  {tabData &&
                    Object.entries(tabData).map(([key, count], i) => {
                      return (
                        <li
                          key={key}
                          className={`flex justify-start items-center cursor-pointer capitalize 
          ${activeTab === `#${key}` ? "text-1D4469 bg-slate-50 rounded" : "text-848687  hover:text-6B8AA8 hover:bg-slate-50 rounded"}`}
                          onClick={() => tabListHandler(key)}
                        >
                          <Checkbox checked={activeTab === `#${key}`} />
                          <span className="flex mr-2">{key}</span>
                        </li>
                      );
                    })}
                </ul>
              }
              <hr />

              <div className="p-2 flex justify-end">
                <Button onClick={() => setShowTabList(false)}>Ok</Button>
              </div>
            </div>
          </CreatePortalHOC>
        )}
      </div>
    </div>
  );
}

export default ScrollableTabs;
